var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_316_15132)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.666,
    y: 10.667,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#5B1DEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.666,
    y: 10.667,
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_316_15132)",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_316_15132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6909 24.7753C32.4427 24.5417 32.186 24.3011 32.0825 24.0831C31.987 23.8834 31.9642 23.5454 31.9421 23.218C31.9008 22.6093 31.8546 21.9196 31.3495 21.4647C30.8444 21.0099 30.1536 21.0361 29.5439 21.0587C29.216 21.0709 28.8774 21.0836 28.6689 21.0094C28.4419 20.9293 28.1751 20.6992 27.9168 20.4768C27.4645 20.0856 26.9506 19.6425 26.299 19.6766C25.6474 19.7108 25.1833 20.2051 24.7737 20.6415C24.5401 20.8897 24.2994 21.1464 24.0814 21.2498C23.883 21.3453 23.5438 21.3681 23.2163 21.3903C22.6077 21.4316 21.9179 21.4778 21.4631 21.9829C21.0083 22.488 21.0376 23.1787 21.057 23.7885C21.0692 24.1164 21.0819 24.455 21.0077 24.6635C20.9276 24.8905 20.6975 25.1573 20.4751 25.4155C20.0839 25.8679 19.6408 26.3818 19.6749 27.0334C19.7091 27.685 20.2034 28.1491 20.6398 28.5587C20.888 28.7923 21.1447 29.0329 21.2482 29.251C21.3437 29.4506 21.3665 29.7886 21.3886 30.116C21.4299 30.7247 21.4761 31.4145 21.9812 31.8693C22.4863 32.3241 23.1771 32.2979 23.7868 32.2754C24.1147 32.2632 24.4533 32.2504 24.6618 32.3246C24.8888 32.4047 25.1556 32.6348 25.4139 32.8573C25.8662 33.2485 26.3801 33.6916 27.0317 33.6574C27.6833 33.6233 28.1474 33.1289 28.557 32.6925C28.7906 32.4443 29.0313 32.1876 29.2493 32.0842C29.4489 31.9886 29.787 31.9659 30.1144 31.9437C30.723 31.9025 31.4128 31.8563 31.8676 31.3512C32.3224 30.8461 32.2963 30.1552 32.2737 29.5456C32.2615 29.2176 32.2488 28.8791 32.323 28.6705C32.4031 28.4435 32.6332 28.1768 32.8556 27.9185C33.2468 27.4662 33.6899 26.9523 33.6558 26.3007C33.6216 25.6491 33.1273 25.1849 32.6909 24.7753ZM29.4552 25.373L26.1432 29.0514C26.0992 29.1002 26.0461 29.1399 25.9868 29.1682C25.9275 29.1965 25.8632 29.2129 25.7976 29.2163C25.732 29.2198 25.6663 29.2102 25.6044 29.1883C25.5424 29.1663 25.4854 29.1324 25.4366 29.0884L23.8602 27.669C23.7616 27.5802 23.7023 27.4559 23.6954 27.3234C23.6884 27.1909 23.7344 27.061 23.8232 26.9624C23.9119 26.8638 24.0363 26.8045 24.1688 26.7976C24.3013 26.7906 24.4311 26.8366 24.5297 26.9254L25.7344 28.0107L28.7116 24.7035C28.7556 24.6547 28.8087 24.615 28.868 24.5867C28.9273 24.5584 28.9916 24.5421 29.0572 24.5386C29.1228 24.5352 29.1885 24.5447 29.2504 24.5667C29.3123 24.5886 29.3694 24.6225 29.4182 24.6665C29.467 24.7104 29.5067 24.7636 29.535 24.8229C29.5632 24.8822 29.5796 24.9464 29.583 25.0121C29.5865 25.0777 29.5769 25.1433 29.555 25.2052C29.5331 25.2672 29.4992 25.3242 29.4552 25.373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3069 19.8268C26.8879 19.7964 27.3557 20.1901 27.8186 20.5905C27.9468 20.7009 28.0829 20.8179 28.2152 20.9169C28.3458 21.0147 28.4835 21.1033 28.6186 21.151C28.7456 21.1962 28.9016 21.2113 29.0572 21.216C29.2149 21.2208 29.3869 21.2148 29.5497 21.2088C30.1728 21.1857 30.7966 21.1691 31.249 21.5764C31.7013 21.9837 31.75 22.6058 31.7922 23.228C31.8032 23.3905 31.8153 23.5622 31.8365 23.7185C31.8522 23.8342 31.8741 23.9494 31.9087 24.0511L31.947 24.1479C32.0087 24.2777 32.111 24.4059 32.222 24.5256C32.3343 24.6467 32.4649 24.769 32.588 24.8849C33.0348 25.3042 33.4751 25.7275 33.5056 26.3085C33.536 26.8896 33.1423 27.3574 32.7419 27.8203C32.6314 27.9485 32.5145 28.0846 32.4155 28.2168C32.3177 28.3475 32.2291 28.4852 32.1814 28.6203C32.1362 28.7473 32.121 28.9033 32.1164 29.0588C32.1116 29.2165 32.1175 29.3886 32.1236 29.5513C32.1467 30.1745 32.1633 30.7983 31.756 31.2506C31.3487 31.703 30.7265 31.7517 30.1044 31.7939C29.9419 31.8049 29.7702 31.817 29.6139 31.8382C29.4597 31.8591 29.3061 31.8905 29.1845 31.9487C29.0547 32.0103 28.9265 32.1127 28.8068 32.2237C28.6857 32.336 28.5634 32.4665 28.4475 32.5897C28.0282 33.0365 27.6049 33.4768 27.0238 33.5072C26.4428 33.5377 25.975 33.1439 25.5121 32.7435C25.3839 32.6331 25.2478 32.5161 25.1155 32.4171C24.9849 32.3194 24.8472 32.2308 24.7121 32.1831C24.5851 32.1379 24.4291 32.1227 24.2735 32.118C24.1159 32.1133 23.9438 32.1192 23.781 32.1253C23.1579 32.1483 22.5341 32.1649 22.0817 31.7576C21.6294 31.3503 21.5807 30.7282 21.5385 30.1061C21.5275 29.9436 21.5154 29.7718 21.4942 29.6155C21.4785 29.4998 21.4566 29.3846 21.422 29.2829L21.3837 29.1862C21.322 29.0563 21.2197 28.9282 21.1087 28.8084C20.9964 28.6873 20.8658 28.5651 20.7427 28.4492C20.2959 28.0298 19.8556 27.6066 19.8251 27.0255C19.7947 26.4445 20.1885 25.9767 20.5889 25.5137C20.6993 25.3855 20.8162 25.2494 20.9152 25.1172C21.013 24.9865 21.1016 24.8488 21.1493 24.7138C21.1945 24.5868 21.2097 24.4307 21.2143 24.2752C21.2191 24.1178 21.2132 23.9462 21.2072 23.7837C21.1872 23.1588 21.1674 22.5358 21.5747 22.0834C21.982 21.631 22.6042 21.5824 23.2263 21.5402C23.3888 21.5292 23.5613 21.5171 23.7178 21.4958C23.8718 21.4749 24.0252 21.4435 24.1462 21.3854L24.1452 21.3845C24.2752 21.3228 24.4041 21.2215 24.5239 21.1103C24.645 20.9981 24.7673 20.8675 24.8832 20.7444C25.3025 20.2976 25.7258 19.8573 26.3069 19.8268ZM29.0494 24.3887C28.9641 24.3932 28.8804 24.4147 28.8033 24.4515C28.7263 24.4883 28.6571 24.5396 28.6 24.603L25.7232 27.798L24.6302 26.8138C24.502 26.6984 24.3331 26.6387 24.1609 26.6477C23.9887 26.6567 23.8269 26.7338 23.7115 26.8619C23.5961 26.9901 23.5364 27.159 23.5454 27.3312C23.5545 27.5034 23.6315 27.6652 23.7597 27.7806L25.3361 29.2C25.3995 29.2571 25.4737 29.3009 25.5541 29.3294C25.6347 29.358 25.7201 29.3706 25.8054 29.3661C25.8907 29.3616 25.9744 29.3401 26.0515 29.3033C26.1285 29.2666 26.1977 29.2153 26.2548 29.1519L29.5668 25.4735C29.6239 25.4101 29.6677 25.3359 29.6962 25.2555C29.7247 25.175 29.7374 25.0895 29.7329 25.0042C29.7285 24.9189 29.7069 24.8352 29.6702 24.7581C29.6334 24.6811 29.5821 24.6119 29.5187 24.5548C29.4553 24.4977 29.3811 24.454 29.3007 24.4254C29.2202 24.3969 29.1347 24.3843 29.0494 24.3887Z",
    stroke: "#202020",
    strokeWidth: 0.3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_316_15132",
    x: -0.000653028,
    y: 0.000323534,
    width: 53.3333,
    height: 53.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.66667,
    dy: 2.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_316_15132"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.66667,
    dy: -2.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_316_15132",
    result: "effect2_dropShadow_316_15132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_316_15132",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_316_15132",
    x: 19.6738,
    y: 19.6748,
    width: 14.9844,
    height: 14.9844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_316_15132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_316_15132",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_15132",
    x1: 26.666,
    y1: 10.667,
    x2: 26.666,
    y2: 31.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.601f6e9e1fb0bb2d98e9561879db5340.svg";
export { ForwardRef as ReactComponent };